import { useCallback, useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import { userState } from "../../../../recoil/auth";
import { WalletAreaPubResponse, getWalletItems } from "../../../../api/member";
import { mySeed } from "../../../../api/seed";

const useWalletPub = () => {
  const user = useRecoilValue(userState);
  const [walletLoading, setWalletLoading] = useState(true);
  const [walletList, setWalletList] = useState<WalletAreaPubResponse[]>([]);
  const [seed, setSeed] = useState(0);

  const getWalletList = useCallback(() => {
    if (!user?.id) {
      return;
    }

    setWalletLoading(true);
    getWalletItems()
      .then((res) => {
        setWalletList(res);
      })
      .catch((e: any) => {
        console.error(e);
      })
      .finally(() => {
        setTimeout(() => {
          //setWalletLoading(false);
        }, 180);
      });
  }, [user]);

  useEffect(() => {
    getWalletList();
  }, [getWalletList]);

  const getSeed = useCallback(() => {
    if (!user) return;
    mySeed()
      .then((seed) => {
        setSeed(seed);
      })
      .catch((e: any) => {
        setSeed(0);
      });
    setTimeout(() => {
      setWalletLoading(false);
    }, 180);
  }, [user]);

  useEffect(() => {
    getSeed();
  }, [getSeed]);

  return {
    walletLoading,
    walletList,
    seed,
  };
};

export default useWalletPub;
